let state = {};

export const setFilterState = (newState) => {
  state = newState;
};

export const getFilterState = () => state;
